import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ModalManagerContext } from '../../ModalsManager';
import useFetch from '../../../utils/useFetch';
import TopWidgetPanelDesktop from './TopWidgetPanelDesktop';
import TopWidgetPanelMobile from './TopWidgetPanelMobile';

const url = `${process.env.REACT_APP_API_URL}/analytics/top`;

const TopWidgetPanel = () => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const openModal = useContext(ModalManagerContext);
  const { render } = useFetch(url, openModal);

  return render((data) => {
    return isMobile ? (
      <TopWidgetPanelMobile data={data} />
    ) : (
      <TopWidgetPanelDesktop data={data} />
    );
  });
};

export default TopWidgetPanel;
